import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  validateLoading: false,
  validateError: false,
  invalidEmails: [],
  alreadyInvited: [],
};

export const validMailSlice = createSlice({
  name: "validMail",
  initialState,
  reducers: {
    validateMailStart: (state) => ({
      ...state,
      validateLoading: true,
      validateError: false,
    }),
    validateMailSuccess: (state, action) => ({
      ...state,
      validateLoading: false,
      invalidEmails: action.payload?.invalidEmails,
      alreadyInvited: action.payload?.alreadyInvited,
    }),
    validateMailFailure: (state) => ({
      ...state,
      validateLoading: false,
      validateError: true,
    }),
    resetMail: () => ({
      ...initialState
    })
  },
});

const { actions, reducer } = validMailSlice;

export const { 
  validateMailStart,
  validateMailSuccess,
  validateMailFailure,
  resetMail,
} = actions;

export const validateMails = (payload) => (dispatch) => {
  dispatch(validateMailStart());
  apiService.post(`${Constants.API.VALID_MAIL}`, payload).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success && Object.keys(data?.data).length) {
      dispatch(validateMailSuccess(data?.data));
    } else {
      dispatch(validateMailFailure());
    }
  }).catch(() => {
      dispatch(validateMailFailure());
  })
}

export default reducer;
